import { ca } from '@cian/analytics';

export const trackVideoPlaying = (videoSource: 'youtube' | 'kinescope') => {
  ca('eventSite', {
    action: `Click_sopr`,
    category: 'gallery',
    label: 'video',
    name: 'oldevent',
    page: {
      extra: {
        video_source: videoSource,
      },
    },
    useLastProducts: true,
  });
};
